import * as React from 'react';
import { CmsArticle } from '@/types/article';

const ArticleContext = React.createContext<CmsArticle | null>(null);

export const ArticleProvider = ArticleContext.Provider;

/**
 * The current CMS page read as an article, if it carries the article fields.
 *
 * Lets a CMS block render the page's own headline, image, date and labels without the
 * editor filling anything in twice, so placing the block is the only authoring step.
 */
export const useArticle = (): CmsArticle | null => {
	return React.useContext(ArticleContext);
};
